import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=65f75eca&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f75eca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f75eca')) {
      api.createRecord('65f75eca', component.options)
    } else {
      api.reload('65f75eca', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=65f75eca&scoped=true&", function () {
      api.rerender('65f75eca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oICB6BKEZJ4t/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports